import clsx from 'clsx';
import { ChevronLeft, ChevronRight } from '@insify/design-system/icons';
import { Section } from '~components/Section';
import { Heading } from '~components/Heading';
import { Carousel, CarouselControl, CarouselPageIndicator, CarouselSlider } from '~components/Carousel';
import { applyMarker } from '~utils/applyMarker';
import { ComponentReviewsSpotlightItem } from './ComponentReviewsSpotlightItem';

import * as styles from './ComponentReviewsSpotlight.module.css';

import type { ContentBlock } from '~components/types';
import type { ComponentReviewsProps } from '../types';

export const ComponentReviewsSpotlight: ContentBlock<ComponentReviewsProps> = ({
  content: { heading, items, carouselInterval },
  ...sectionProps
}) => (
  <Section {...sectionProps} blockLayout='boxed' className={clsx(styles.section, styles.boxed)}>
    <Carousel
      config={{
        all: {
          slidesToShow: 1,
          slideGap: '0px',
          autoplay: true,
          autoplayInterval: carouselInterval,
        },
      }}
    >
      <Heading className={styles.heading} level={2}>
        {applyMarker(heading, { animated: true, markerColor: 'var(--green-50)' })}
      </Heading>
      <CarouselSlider className={styles.carouselSlider}>
        {items.map((item) => (
          <div key={item.content.content} className={styles.itemWrapper}>
            <ComponentReviewsSpotlightItem content={item} />
          </div>
        ))}
      </CarouselSlider>
      <div className={styles.controls}>
        <CarouselControl className={styles.stepperButton} navigationDelta={-1}>
          <ChevronLeft />
        </CarouselControl>
        <CarouselPageIndicator className={styles.pageIndicator} progressBarMode activateOnIndex='all' />
        <CarouselControl className={styles.stepperButton} navigationDelta={1}>
          <ChevronRight />
        </CarouselControl>
      </div>
    </Carousel>
  </Section>
);
